import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { loadReports } from '../actions/actions';

class RefreshButton extends React.Component {
  loadReports = () => {
    this.props.loadReports();
  };
  render() {
    return (
      <button onClick={this.loadReports} className="RefreshButton" aria-label="Meldungen neu laden">
        <i className="fa fa-refresh" aria-hidden="true" />
      </button>
    );
  }
}

RefreshButton.propTypes = {
  loadReports: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  loadReports: () => {
    dispatch(loadReports());
  },
});

export default connect(null, mapDispatchToProps)(RefreshButton);



// WEBPACK FOOTER //
// ./src/js/components/RefreshButton.js